import React, { useEffect, useState } from 'react';
import { GetPacsConfer } from '../Adapters/GetPacsConfer';

const useGetPacsConfer = (idPatientString) => {
  const [pacsConfer, setPacsConfer] = useState(null);
  useEffect(() => {
    GetPacsConfer(setPacsConfer, idPatientString);
  }, [idPatientString]);
  return pacsConfer;
};

export default useGetPacsConfer;
